import { LogLevel } from "@husbanken/angular-starter";
import { Environment } from "../app/shared/models/environment.model";

export const environment: Environment = {
  production: true,
  version: import("../../package.json")["version"],
  logLevel: LogLevel.WARN,
  appConfig: "konfig/app.config.json",
  keycloakConfig: "konfig/keycloak-[realm].json",
  klientloggerPath: "/klientlogger/log/tjenester-senddokument",
};
